import GestionCategories from '@/components/GestionCategories/GestionCategories.vue'
import GestionFamilles from '@/components/GestionFamilles/GestionFamilles.vue'
import GestionArticles from '@/components/GestionArticles/GestionArticles.vue'
import NouvellesCommandes from '@/components/NouvellesCommandes/NouvellesCommandes.vue'
import CommandeAEnvoyer from '../../../components/CommandeAEnvoyer/CommandeAEnvoyer.vue'
import CommandesEnvoyees from '../../../components/CommandesEnvoyees/CommandesEnvoyees.vue'
import CommandesArchivees from '../../../components/CommandesArchivees/CommandesArchivees.vue'
import CommandesAnnulees from '../../../components/CommandesAnnulees/CommandesAnnulees.vue'
import Utilisateurs from '@/components/Utilisateurs/Utilisateurs.vue'
import {
  mapActions
} from 'vuex'
export default {
  data() {
    return {
      currentDisplay: 'cat',
    }
  },
  components: {
    GestionCategories,
    GestionFamilles,
    GestionArticles,
    NouvellesCommandes,
    CommandeAEnvoyer,
    CommandesEnvoyees,
    CommandesArchivees,
    CommandesAnnulees,
    Utilisateurs
  },
  computed: {},
  methods: {
    ...mapActions(['getCategories', 'getUser']),
    // General
    displaySection(pCurrentDisplay) {
      this.currentDisplay = pCurrentDisplay
    },
    goToStore() {
      this.$router.push('/')
    }
  },
  mounted() {
    this.getUser().then(res => {
      this.getCategories().then(res => {

      }).catch(err => {
        console.log(err)
      })
    }).catch(err => {
      console.log(err)
    })

  },

  filters: {
    formatDate: function (value) {
      if (!value) return ''
      const date = new Date(value)
      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }
      return date.toLocaleDateString('fr-FR', options)
    },
    toFirstUpperCase: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
}